export enum SlideStartPosition {
  Left,
  Right,
  Top,
  Bottom
}